export const isHtmlContent = (value) => {
  if (!value || typeof value !== "string") return false;
  return /<[a-z][\s\S]*>/i.test(value);
};

export const isRichTextEmpty = (value) => {
  if (!value || !String(value).trim()) return true;

  const stripped = String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  return !stripped;
};

export const plainTextToRichText = (value) => {
  if (!value || !String(value).trim()) return "";
  if (isHtmlContent(value)) return value;

  return String(value)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => `<p>${line}</p>`)
    .join("");
};

export const PROJECT_INFO_EDITOR_MODULES = {
  toolbar: [[{ list: "ordered" }, { list: "bullet" }]],
};

/** @deprecated Use PROJECT_INFO_EDITOR_MODULES */
export const PROJECT_ADDRESS_EDITOR_MODULES = PROJECT_INFO_EDITOR_MODULES;

export default isRichTextEmpty;
